<template>
  <div class="page-container">
    <div id="searchArea">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList(1)">
        <div class="clearfix">
          <div class="fl pb10">
            <el-button type="primary" class="fs14" @click="synchronous" v-if="isAuth('sys:user:sync')">Sync</el-button>
          </div>
          <div class="fr">
            <el-form-item>
              <el-select v-model="dataForm.roleId" clearable placeholder="Role Name" class="wd150">
                <el-option v-for="item in roleList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input v-model="dataForm.nickname" placeholder="Nick Name" clearable v-regexFilter="halfWidthRegex" class="wd150"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="dataForm.staffNo" placeholder="Staff No." clearable v-regexFilter="halfWidthRegex"></el-input>
            </el-form-item>
            <el-form-item>
              <el-input v-model="dataForm.position" placeholder="Position" clearable v-regexFilter="halfWidthRegex"></el-input>
            </el-form-item>
            <el-form-item>
              <el-select v-model="dataForm.supplierId" filterable clearable placeholder="Supplier">
                <el-option v-for="item in allSupplierList" :key="item.id" :label="item.companyName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" type="primary" plain v-debounce @click="getDataList(1)">Search</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <div>
      <el-table max-height="680" :data="dataList" v-loading="dataListLoading" style="width: 100%">
        <el-table-column prop="id" align="center" width="70" label="ID" fixed="left"></el-table-column>
        <el-table-column prop="email" align="center" width="200" label="Email" fixed="left"></el-table-column>
        <el-table-column prop="nickname" align="center" width="120" label="Nick Name" fixed="left"></el-table-column>
        <el-table-column prop="staffNo" align="center" width="120" label="Staff No." fixed="left"></el-table-column>
        <el-table-column prop="position" align="center" width="150" label="Position"></el-table-column>
        <el-table-column prop="employers" align="center" width="150" label="Employer">
          <template slot-scope="scope">
            <p v-if="scope.row.employers">{{ scope.row.employers.join(", ") }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="phone" align="center" width="150" label="Phone"></el-table-column>
        <el-table-column prop="roleList" align="center" width="180" label="Role" :formatter="roleListToStringFormatter"></el-table-column>
        <el-table-column prop="createTime" align="center" width="180" label="Register Date"></el-table-column>
        <el-table-column prop="status" align="center" width="100" label="Status" :formatter="enableAndDisableFormat"></el-table-column>
        <el-table-column align="center" label="Supplier" width="200">
          <template slot-scope="scope">
            <p>{{ supplierAbbrDeduplicateFormat(scope.row.supplierList) }}</p>
          </template>
        </el-table-column>
        <el-table-column label="Replacement User" align="center" width="156">
          <template slot-scope="scope">
            <p>{{ scope.row.replacementUser?.nickname || "" }}</p>
          </template>
        </el-table-column>
        <el-table-column prop="remark" align="center" min-width="150" label="Remark" show-overflow-tooltip></el-table-column>
        <el-table-column fixed="right" align="center" width="120" label="Action">
          <template slot-scope="scope">
            <el-button v-if="isAuth('sys:user:update')" type="text" class="fwb" @click="editHandle(scope.row)">Roles</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <pagination
      :current="current"
      :pageSize="pageSize"
      :totalCount="totalCount"
      @size-change="sizeChangeHandle"
      @current-change="currentChangeHandle"
    ></pagination>

    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update ref="addOrUpdate" :allSupplierList="allSupplierList" @refreshDataList="updateHandle"></add-or-update>
  </div>
</template>

<script>
import AddOrUpdate from "./modal/AddOrUpdate";
import Pagination from "@/components/Pagination";
import formatterMixin from "@/mixins/formatterMixin";
import paginationMixin from "@/mixins/paginationMixin";
import { mapGetters, mapMutations } from "vuex";
export default {
  mixins: [formatterMixin, paginationMixin],
  components: {
    AddOrUpdate,
    Pagination,
  },
  data() {
    return {
      dataForm: {
        roleId: "",
        nickname: "",
        staffNo: "",
        position: "",
        supplierId: null,
        "orders[0].asc": false,
        "orders[0].column": "t1.id",
      },
      dataList: [],
      allSupplierList: [],
      dataListLoading: false,
    };
  },
  computed: {
    ...mapGetters("role", ["roleList"]),
  },
  methods: {
    ...mapMutations("role", ["initRoles"]),
    // 获取角色列表
    fetchRoles() {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/admin/sysRole/getList")
          .then(res => {
            const resData = res.data || [];
            this.initRoles(resData);
            resolve();
          })
          .catch(err => {
            reject();
          });
      });
    },
    // 获取供应商列表 - 所有的供应商
    getAllSupplierList() {
      return new Promise((resolve, reject) => {
        this.$http
          .get("/admin/supplier/getAllList")
          .then(res => {
            this.allSupplierList = res.data || [];
            resolve();
          })
          .catch(err => {
            reject();
          });
      });
    },
    // 获取数据列表
    async getDataList(current) {
      this.dataListLoading = true;
      if (current) {
        this.current = current;
      }
      const params = {
        current: this.current,
        size: this.pageSize,
        ...this.dataForm,
      };
      const { code, data } = await this.$http.get("/admin/sysUser/paging", {
        params,
      });
      if (code === 200) {
        this.dataList = data.records;
        this.totalCount = data.total;
      } else {
        this.dataList = [];
        this.totalCount = 0;
      }
      this.dataListLoading = false;
    },
    // 同步
    synchronous() {
      this.$http.post("/admin/sysUser/pull").then(res => {
        this.$message.success("Successful");
        this.getDataList(1);
      });
    },
    // 修改
    editHandle(data) {
      this.$refs.addOrUpdate.init(data);
    },
    // 子组件更新
    async updateHandle() {
      try {
        this.dataListLoading = true;
        await this.getAllSupplierList();
      } catch (error) {
      } finally {
        this.getDataList();
      }
    },
  },
  async activated() {
    try {
      this.dataListLoading = true;
      await this.fetchRoles();
      await this.getAllSupplierList();
    } catch (error) {
    } finally {
      this.getDataList();
    }
  },
};
</script>

<style lang="scss" scoped>
.flex-row {
  .sync {
    margin-left: auto;
    margin-right: 0px;
  }
}
</style>
